/**
 @ngdoc directive
 @name progressBarLoader

 @description
 Draws a Progress Bar Animated Loader

 @usage
 <progress-bar-loader average-time="1000" id="nameMe"></progress-bar>

 @param {string}    id               - unique name
 @param {int}       average-time     - average time for a page load in millseconds

 */

(function() {
    'use strict';
    var progressBarLoader = function ($templateCache,progressBarService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            bindToController: {
                id: "@",
                averageTime: "@"
            },
            controllerAs: "ctrl",
            scope: true,
            template: $templateCache.get('components/progressBarLoader.html'),
            controller: function($scope) {
                var _this = this;
                this.$onInit = function() {
                    if(!$scope.progressBar) {
                        $scope.progressBar = progressBarService.init($scope);
                    }
                    console.log('progressBar',_this.id);
                    progressBarService.addBar(_this.id,_this.averageTime);
                    progressBarService.start(_this.id);
                };

            }
        };
    };

    progressBarLoader.$inject = ['$templateCache', 'progressBarService'];
    angular.module('app').directive('progressBarLoader', progressBarLoader);

}());